module.exports = __webpack_public_path__ + "img/Santa Barbara depth.3a0efd7a.jpg";